import type { ApiClient } from '@travel/api-client';

import { MONTEROSA_API_TIMEOUT } from 'store/utils';

import type { ProviderDetails } from 'ProviderDetails-Types';
import type { SearchEngine } from 'SearchEngine-Types';
export const fetchProviderDetails = (
  http: ApiClient,
  id: string,
  ipAddress?: string,
  searchEngine?: SearchEngine,
): Promise<ProviderDetails> => {
  const headers = ipAddress ? { 'trv-client-ip': ipAddress } : undefined;
  return http.post(`/monterosa-api-dp/dp/jrdp/provider-details/`, {
    values: { id, searchEngine },
    timeout: MONTEROSA_API_TIMEOUT,
    headers,
  });
};
